import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Grid, Typography } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService, setReRender, handleSnackBar } from '../../../store/global/actions'
import { getDetailsFromUrl } from '../../../services/blueprint'

const DeleteSimulation = (props) => {

    const { onClose, onCompletion, element } = props
    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { slug, blueprintId } = getDetailsFromUrl();
    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteSimulation', {}, [element.id]))
            .then((response) => {
                if (response.status) {
                    if (response?.data?.nextSimulation) {
                        history.push(`/blueprint/${slug}/${blueprintId}/simulation/${response?.data?.nextSimulation?._id}`);
                    } else {
                        history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    }
                    dispatch(setReRender());
                    onCompletion()

                } else if (response?.status == false && response?.code) {
                    onCompletion()
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                }
                else {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
                }
                setLoading(false);

            })

    }

    return (
        <Grid container direction={"row"} spacing={1} >
            <Grid item xs={12}>
                <Typography variant="h6">Delete</Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography> Are you sure you want to delete Simulation {element?.name ? element?.name : ''} ? </Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", textTransform: 'capitalize' }} >
                <DeleteCancel onCancel={onClose} onDelete={onDelete} disableButton={loading} content={loading ? 'Deleting..' : 'Delete'} />
            </Grid>


        </Grid>
    )
}

export default DeleteSimulation;